import React from "react";

const CategorySmallCards2 = () => {
  return (
    <div className="relative w-full">
      <div className="max-w-sm  duration-300 hover:scale-105 transition-all hover:shadow-lg mx-1 rounded-lg border border-gray-200 shadow-md">
        <span class="text-center bg-orange-400 p-2 text-white rounded-t-lg text-sm font-semibold shadow-md inline-block w-full">
          50% OFF
        </span>
        <a href="/" className="w-full bg-slate-100 overflow-hidden">
          <img className="rounded-t-sm p-10" src="/images/watch.png" alt="" />
        </a>
        <div className=" py-3 px-0.5 lg:py-2">
          <h1 className="text-center text-lg md:text-md w-full font-bold font-mono">
            smart Phones
          </h1>
        </div>
      </div>
    </div>
  );
};

export default CategorySmallCards2;
